import { ImgID } from "../image_loader/img_id.js";

// infinite_hearts and no_ads are timed: amount is minutes, not a count.
export type AdventureRewardType = "coin" | "heart" | "infinite_hearts" | "no_ads" | "fireworks" | "multiballs" | "big_balls" | "infinite_balls" | "mines";

export interface AdventureBoxReward
{
  type: AdventureRewardType;
  amount: number;
}

export const ADVENTURE_REWARD_ICONS: Record<AdventureRewardType, ImgID> = {
  coin: ImgID.IconCoin,
  heart: ImgID.IconHeart,
  infinite_hearts: ImgID.UI_ShopInfiniteHeart,
  no_ads: ImgID.UI_RemoveAdsIcon,
  fireworks: ImgID.UI_RocketBooster,
  multiballs: ImgID.UI_GameStartMultiballsBooster,
  big_balls: ImgID.UI_GameStartBigBallBooster,
  infinite_balls: ImgID.UI_GameStartInfiniteBallsBooster,
  mines: ImgID.UI_PassiveBoosterBomb,
};

export const ADVENTURE_BOX_REWARDS: Record<number, AdventureBoxReward[]> = {
  5: [
    { type: "coin", amount: 10 },
    { type: "coin", amount: 10 },
  ],
  10: [
    { type: "coin", amount: 15 },
    { type: "heart", amount: 1 },
    { type: "coin", amount: 15 },

  ],
  15: [
    { type: "multiballs", amount: 1 },
  ],
  20: [
    { type: "coin", amount: 25 },
    { type: "fireworks", amount: 2 },
    { type: "coin", amount: 25 },
    { type: "multiballs", amount: 1 },
    { type: "coin", amount: 25 },
    { type: "heart", amount: 1 },
  ],
  25: [
    { type: "coin", amount: 30 },
    { type: "big_balls", amount: 2 },
    { type: "coin", amount: 30 },
    { type: "infinite_balls", amount: 1 },
    { type: "coin", amount: 30 },
    { type: "heart", amount: 1 },
  ],
  30: [
    { type: "coin", amount: 40 },
    { type: "fireworks", amount: 2 },
    { type: "multiballs", amount: 2 },
    { type: "big_balls", amount: 1 },
    { type: "coin", amount: 40 },
    { type: "heart", amount: 2 },
  ],
  35: [
    { type: "coin", amount: 50 },
    { type: "infinite_balls", amount: 2 },
    { type: "fireworks", amount: 3 },
    { type: "multiballs", amount: 2 },
    { type: "big_balls", amount: 2 },
    { type: "heart", amount: 2 },
  ],
};

export function getAdventureBoxRewards( floor_level: number ): AdventureBoxReward[]
{
  return ADVENTURE_BOX_REWARDS[ floor_level ] ?? [];
}
